import { useState } from 'react';

export default function CtaPanel() {
  const [sent, setSent] = useState(false);

  const handle = () => {
    setSent(true);
    window.setTimeout(() => setSent(false), 2200);
  };

  return (
    <section className="mx-auto w-full max-w-[1200px] px-4 pb-16 pt-4 md:px-6">
      <div className="overflow-hidden rounded-3xl bg-gradient-to-br from-orange-500 via-orange-500 to-rose-500">
        <div className="relative flex flex-col items-start gap-6 p-7 md:p-10 lg:flex-row lg:items-center lg:justify-between">
          <div className="pointer-events-none absolute -right-10 -top-16 h-48 w-48 rounded-full bg-white/10 blur-2xl" />
          <div className="relative max-w-xl">
            <h2 className="text-2xl font-black leading-snug tracking-tight text-white md:text-3xl">
              入口失效了？别急着走，
              <br />
              这里会持续补新地址
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-orange-50">
              找不到想看的内容、入口打不开，直接在这里说一声。我们持续收录并补充新直达，
              收藏这一个看料地址就够了。
            </p>
          </div>
          <div className="relative w-full max-w-sm">
            <div className="flex items-center gap-2 rounded-xl bg-white p-1.5">
              <i className="ri-error-warning-line pl-2 text-xl text-orange-500" />
              <input
                placeholder="填写失效入口或想看的类别…"
                className="w-full min-w-0 bg-transparent text-sm outline-none placeholder:text-stone-300"
              />
              <button
                type="button"
                onClick={handle}
                className="whitespace-nowrap rounded-lg bg-orange-500 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-orange-600"
              >
                提交反馈
              </button>
            </div>
            {sent && (
              <p className="mt-2 text-xs text-orange-100">已收到反馈（演示效果，未实际提交）</p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}